module.exports = __webpack_public_path__ + "static/media/feitosa.11812fe4.png";